module.exports = __webpack_public_path__ + "static/media/es.7795f2cb.svg";